import React, { useState, useEffect, useRef } from "react";
import SingleFileUpload from "../common/SingleDropzoneComponent";
import CustomDropdown from "../common/CustomDropdown";
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import axios from "axios";
import { baseUrl } from "../../api/common";
import dayjs from "dayjs";
import { FormCheck } from "react-bootstrap";
import "react-phone-number-input/style.css";
import ReactPhoneInput from "react-phone-number-input";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import Datepicker from '../common/datepicker';
const UpdateMembershipApplicationComponent = ({
  memberId,
  eventType,
  fetchPreviewMemberDetailsData,
  memberApplicationId,
  addPopupStatus,
  handleUpdatePopup
}) => {
  const dateFormatList = "YYYY-MM-DD";

  const genderData = [
    {
      id: 1,
      value: "Male",
    },
    {
      id: 2,
      value: "Female",
    },
    {
      id: 3,
      value: "Others",
    }
  ];
    const salutationData = [
    {
      id: 1,
      value: "Dr.",
    },
    {
      id: 2,
      value: "Mr.",
    },
    {
      id: 3,
      value: "Mrs",
    },
    {
      id: 4,
      value: "Ms.",
    },
    {
      id: 5,
      value: "Prof",
    },
    {
      id: 6,
      value: "Surgeon",
    }
  ];
  const AllzoneData = [
    {
      id: 1,
      value: "South Zone",
      states: [
        "Andhra Pradesh",
        "Telangana",
        "Karnataka",
        "Tamil Nadu",
        "Kerala",
        "Puducherry", // UT
        "Lakshadweep", // UT
      ],
    },
    {
      id: 2,
      value: "North Zone",
      states: [
        "Jammu and Kashmir", // UT
        "Ladakh", // UT
        "Himachal Pradesh",
        "Punjab",
        "Haryana",
        "Delhi", // UT
        "Uttarakhand",
        "Uttar Pradesh",
        "Chandigarh", // UT
      ],
    },
    {
      id: 3,
      value: "East Zone",
      states: [
        "Bihar",
        "Jharkhand",
        "Odisha",
        "West Bengal",
        "Sikkim",
        "Assam",
        "Arunachal Pradesh",
        "Meghalaya",
        "Manipur",
        "Mizoram",
        "Nagaland",
        "Tripura",
      ],
    },
    {
      id: 4,
      value: "West Zone",
      states: [
        "Rajasthan",
        "Gujarat",
        "Goa",
        "Maharashtra",
        "Dadra and Nagar Haveli and Daman and Diu", // UT
      ],
    },
    {
      id: 5,
      value: "Central Zone",
      states: [
        "Madhya Pradesh",
        "Chhattisgarh",
        "Andaman and Nicobar Islands", // UT
      ],
    },
  ];

  const yearData = Array.from(
    { length: 100 },
    (_, i) => new Date().getFullYear() - i
  );

  const organisationsData = ["SAGES", "ELSA", "Others"];

  const [applicationId, setApplicationId] = useState(null);
  const [refechTrigger, setRefechTrigger] = useState(false);
  const [updateDropDownValues, setUpdateDropDownValues] = useState([]);
  const [formValues, setFormValues] = useState({
    application_no: "",
    membership_no: "",
    salutation: "",
    first_name: "",
    last_name: "",
    middle_name: "",
    email: "",
    mobile: "",
    mobile_code: "",
    father_name: "",
    dob: "",
    age: "",
    nationality: "Indian",
    // nationality:"",
    gender: "",
    zone: "",
    street_line1: "",
    street_line2: "",
    country: 101,
    // country:"",
    state: "",
    city: "",
    pin: "",
    landline: "",
    stdcode: "",
    mailing_address: 1,
    edu_undergrad_degree: "",
    edu_undergrad_college: "",
    edu_undergrad_university: "",
    edu_undergrad_year: "",
    edu_postgrad_degree: "",
    edu_postgrad_college: "",
    edu_postgrad_university: "",
    edu_postgrad_year: "",
    edu_superspecialty_degree: "",
    edu_superspecialty_college: "",
    edu_superspecialty_university: "",
    edu_superspecialty_year: "",
    mci_council_number: "",
    mci_council_state: "",
    imr_reg_no: "",
    asi_membership_no: "",
    asi_state: "",
    other_inter_organisation: [],
    other_inter_organisation_value: "",
  });

  const [errors, setErrors] = useState({
    profile: "",
    membership_no: "",
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    father_name: "",
    dob: "",
    age: "",
    nationality: "",
    gender: "",
    street_line1: "",
    street_line2: "",
    country: "",
    state: "",
    city: "",
    pin: "",
    landline: "",
    stdcode: "",
    mailing_address: "",
    // edu_undergrad: "",
    // edu_postgrad: "",
    edu_undergrad_degree: "",
    edu_undergrad_college: "",
    edu_undergrad_university: "",
    edu_undergrad_year: "",
    edu_postgrad_degree: "",
    edu_postgrad_college: "",
    edu_postgrad_university: "",
    edu_postgrad_year: "",
    edu_superspecialty_degree: "",
    edu_superspecialty_college: "",
    edu_superspecialty_university: "",
    edu_superspecialty_year: "",
    mci_council_number: "",
    mci_council_state: "",
    imr_reg_no: "",
    asi_membership_no: "",
    asi_state: "",
    other_inter_organisation: "",
    mci_certificate: "",
    pg_degree_certificate: "",
    asi_member_certificate: "",
    active_license: "",
    letter_hod: "",
    mbbs_degree_certificate: "",
  });
  const scrollToFirstError = () => {
    setTimeout(() => {
      let element = document.querySelector(".red_border");

      // Special handling for phone input
      if (element && element.classList.contains("custom-phone-input")) {
        element = element.querySelector("input");
      }

      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
    }, 100);
  };

  const calculateAge = (birthDate, currentDate = dayjs()) => {
    if (!birthDate) return "";

    const birth = dayjs(birthDate).startOf("day");
    const today = dayjs(currentDate).startOf("day");

    if (!birth.isValid() || !today.isValid()) return "";

    const age = today.diff(birth, "year");
    return age >= 0 ? age.toString() : "";
  };

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };

  const handleOtherOrganizationChange = (e, id) => {
    const isChecked = e.target.checked;
    setFormValues((prev) => {
      const updatedValues = prev.other_inter_organisation || [];
      return {
        ...prev,
        other_inter_organisation: isChecked
          ? [...updatedValues, id]
          : updatedValues.filter((org) => org !== id),
      };
    });
    if (id === "Others" && !isChecked) {
      formValues.other_inter_organisation_value = "";
    }
  };

  //----------------- Profile ----------------
  const [profileFile, setProfileFile] = useState(null);
  const [profileFileError, setProfileFileError] = useState("");
  // const handleProfileFileUpload = (uploadedFile) => {
  //   setProfileFile(uploadedFile);
  //   console.log("Uploaded File:", uploadedFile);
  // };
  const [image, setImage] = useState("../../assets/images/user_image.png");
  const fileInputRef = useRef(null);
  const MAX_SIZE_MB = 2;
  const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
  const ALLOWED_TYPES = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/webp",
    "image/svg+xml",
  ];
  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const imageUrl = URL.createObjectURL(file);
  //     setImage(imageUrl);
  //     setProfileFile(file);
  //   }
  // };
  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      setImage(null);
      setProfileFile(null);
      setErrors((prev) => ({ ...prev, profile: undefined }));
      return;
    }
    if (!ALLOWED_TYPES.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        profile: "Only PNG, JPG, JPEG, WEBP, and SVG files are allowed.",
      }));
      event.target.value = "";
      return;
    }
    if (file.size > MAX_SIZE_BYTES) {
      setErrors((prev) => ({
        ...prev,
        profile: `File too large. Max ${MAX_SIZE_MB} MB`,
      }));
      event.target.value = "";
      return;
    }
    const imageUrl = URL.createObjectURL(file);
    setImage(imageUrl);
    setProfileFile(file);
    setErrors((prev) => ({ ...prev, profile: undefined }));
  };
  //-------------------------------------------------

  //----------------- MCI Certificate----------------
  const [mciCertificateFile, setMciCertificateFile] = useState(null);
  const [mciCertificateError, setMciCertificateError] = useState("");
  const handleMciCertificateUpload = (uploadedFile) => {
    // setFormValues({ ...formValues, mci_certificate: uploadedFile });
    setMciCertificateFile(uploadedFile);
    console.log("Uploaded File:", uploadedFile);
  };
  //-------------------------------------------------

  //----------------- PG Degree Certificate----------------
  const [pgDegreeCertificateFile, setPgDegreeCertificateFile] = useState(null);
  const [pgDegreeCertificateError, setPgDegreeCertificateError] = useState("");
  const handlePgDegreeCertificateUpload = (uploadedFile) => {
    // setFormValues({ ...formValues, pg_degree_certificate: uploadedFile });
    setPgDegreeCertificateFile(uploadedFile);
    console.log("Uploaded File:", uploadedFile);
  };
  //-------------------------------------------------

  //----------------- ASI Member Certificate----------------
  const [asiMemberCertificateFile, setAsiMemberCertificateFile] =
    useState(null);
  const [asiMemberCertificateError, setAsiMemberCertificateError] =
    useState("");
  const handleAsiMemberCertificateUpload = (uploadedFile) => {
    // setFormValues({ ...formValues, asi_member_certificate: uploadedFile });
    setAsiMemberCertificateFile(uploadedFile);
    console.log("Uploaded File:", uploadedFile);
  };
  //-------------------------------------------------

  //----------------- Active License----------------
  const [activeLicenseFile, setActiveLicenseFile] = useState(null);
  const [activeLicenseError, setActiveLicenseError] = useState("");
  const handleActiveLicenseUpload = (uploadedFile) => {
    // setFormValues({ ...formValues, active_license: uploadedFile });
    setActiveLicenseFile(uploadedFile);
    console.log("Uploaded File:", uploadedFile);
  };
  //-------------------------------------------------

  //-----------------Letter HOD----------------
  const [hodLetterFile, setHodLetterFile] = useState(null);
  const [hodLetterError, setHodLetterError] = useState("");
  const handleHodLetterUpload = (uploadedFile) => {
    // setFormValues({ ...formValues, letter_hod: uploadedFile });
    setHodLetterFile(uploadedFile);
    console.log("Uploaded File:", uploadedFile);
  };
  //-------------------------------------------------

  //----------------- MBBS Degree Certificate----------------
  const [mbbsDegreeCertificateFile, setMbbsDegreeCertificateFile] =
    useState(null);
  const [mbbsDegreeCertificateError, setMbbsDegreeCertificateError] =
    useState("");
  const handleMbbsDegreeCertificateUpload = (uploadedFile) => {
    // setFormValues({ ...formValues, mbbs_degree_certificate: uploadedFile });
    setMbbsDegreeCertificateFile(uploadedFile);
    console.log("Uploaded File:", uploadedFile);
  };
  //-------------------------------------------------

  //----------------- Clinic Address----------------

  const [clinicStateData, setClinicStateData] = useState([]);
  const DataRefechRetrigger = async (value) => {
    // const states = await fetchStateData(value);
    // setClinicStateData(states);
    // setRefechTrigger(data);
  };

  const [clinicAddress, setClinicAddress] = useState([
    {
      id: "",
      clinic_name: "",
      clinic_address_one: "",
      clinic_address_two: "",
      clinic_country: "",
      clinic_state: "",
      clinic_city: "",
      clinic_pin_code: "",
      clinic_landline: "",
      clinic_stdcode: "",
      clinic_mailing_address: 0,
    },
  ]);

  const addClinicAddressField = () => {
    setClinicAddress([
      ...clinicAddress,
      {
        id: "",
        clinic_name: "",
        clinic_address_one: "",
        clinic_address_two: "",
        clinic_country: "",
        clinic_state: "",
        clinic_city: "",
        clinic_pin_code: "",
        clinic_landline: "",
        clinic_stdcode: "",
        clinic_mailing_address: 0,
      },
    ]);
  };

  // const removeClinicAddressField = (index, id) => {
  //   if (id !== "") {
  //     deleteClinicAddress(id);
  //   }
  //   setClinicAddress(clinicAddress.filter((_, i) => i !== index));
  // };

  const removeClinicAddressField = (index, id) => {
    if (id !== undefined && id !== null && id !== "") {
      deleteClinicAddress(id);
    }
    setClinicAddress(clinicAddress.filter((_, i) => i !== index));
  };

  const handleClinicAddressChange = async (index, field, value) => {
    const updatedClinicAddress = [...clinicAddress];

    if (index >= updatedClinicAddress.length || index < 0) {
      console.error("Invalid index:", index);
      return;
    }

    updatedClinicAddress[index][field] = value;
    setClinicAddress(updatedClinicAddress);

    if (field === "clinic_country") {
      // Fetch states when country is selected
      const states = await fetchStateData(value);
      const updatedStateData = [...clinicStateData]; // clone the existing state data
      updatedStateData[index] = states; // store states per index
      setClinicStateData(updatedStateData);
    }
  };

  const [clinicAddressErrors, setClinicAddressErrors] = useState({});

  const validateClinicAddressFields = () => {
    let isValid = true;
    const newErrors = {};
    clinicAddress.forEach((detail, index) => {
      if (
        detail.clinic_pin_code.trim() &&
        !/^\d{6}$/.test(detail.clinic_pin_code)
      ) {
        isValid = false;
        newErrors[`clinic_pin_code-${index}`] =
          "Clinic pin code must be 6 digits";
      }
      // if (detail.clinic_landline.trim() && !detail.clinic_stdcode.trim()) {
      //   newErrors[`clinic_landline-${index}`] =
      //     "Clinic STD code cannot be empty";
      // } else if (
      //   !detail.clinic_landline.trim() &&
      //   detail.clinic_stdcode.trim()
      // ) {
      //   newErrors[`clinic_landline-${index}`] =
      //     "Clinic landline cannot be empty";
      // }
    });
    console.log(newErrors, "newErrors");
    setClinicAddressErrors(newErrors);
    return isValid;
  };

  const deleteClinicAddress = async (deleteId) => {
    try {
      console.log(deleteId, "deleteId");
      const response = await axios.post(
        `${baseUrl}/api/delete_clinic`,
        { id: deleteId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.status) {
        showToast(response.data.message, "success");
      } else {
        showToast(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      showToast("A network error occurred, or the server is temporarily busy. Please try again later.", "error");
    }
  };

  // -----------------------------------------------------------------

  //----------------- Procedures----------------

  const [procedures, setProcedures] = useState([
    {
      id: "",
      work_procedure: "",
      exp_in_year: "",
      no_of_procedures1: "",
      no_of_procedures2: "",
    },
  ]);

  const addProceduresField = () => {
    setProcedures([
      ...procedures,
      {
        id: "",
        work_procedure: "",
        exp_in_year: "",
        no_of_procedures1: "",
        no_of_procedures2: "",
      },
    ]);
  };

  const removeProceduresField = (index, id) => {
    if (id !== "") {
      deleteProcedures(id);
    }
    setProcedures(procedures.filter((_, i) => i !== index));
  };

  const handleProceduresChange = (index, field, value) => {
    const updatedClinicAddress = [...procedures];
    updatedClinicAddress[index][field] = value;
    setProcedures(updatedClinicAddress);
  };

  const [proceduresErrors, setProceduresErrors] = useState({});

  const validateProceduresFields = () => {
    let isValid = true;
    const newErrors = {};
    procedures.forEach((data, index) => {
      if (!data.work_procedure.trim()) {
        isValid = false;
        newErrors[`work_procedure-${index}`] = "Work procedure cannot be empty";
      }
      if (!data.exp_in_year.trim()) {
        isValid = false;
        newErrors[`exp_in_year-${index}`] =
          "Experience (in Years) cannot be empty";
      }
      if (!data.no_of_procedures1.trim()) {
        isValid = false;
        newErrors[`no_of_procedures1-${index}`] =
          "No of Procedures (Past 1 Year) cannot be empty";
      }
      if (!data.no_of_procedures2) {
        isValid = false;
        newErrors[`no_of_procedures2-${index}`] =
          "No of Procedures (Past 5 Year) cannot be empty";
      }
    });
    console.log(newErrors, "newErrors");
    setProceduresErrors(newErrors);
    return isValid;
  };

  const deleteProcedures = async (deleteId) => {
    try {
      console.log(deleteId, "deleteId");
      const response = await axios.post(
        `${baseUrl}/api/delete_work_exp`,
        { id: deleteId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.status) {
        showToast(response.data.message, "success");
      } else {
        showToast(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      showToast("A network error occurred, or the server is temporarily busy. Please try again later.", "error");
    }
  };

  // -----------------------------------------------------------------

  const validate = () => {
    const newErrors = {};

    const validateField = (field, message) => {
      if (typeof formValues[field] === "string" && !formValues[field].trim()) {
        newErrors[field] = message;
        console.log(field, typeof formValues[field]);
      }
    };

    const validateDropdownField = (field, message) => {
      if (!formValues[field]) newErrors[field] = message;
    };

    const validateRegex = (field, regex, message) => {
      if (!regex.test(formValues[field])) newErrors[field] = message;
    };

    const validateFile = (file, field, message) => { 
      if (!file && eventType === "Add") newErrors[field] = message;
      if (field === "asi_member_certificate") {  
        if (
          !file &&
          eventType === "Update" &&
          [3, 4].includes(memberApplicationId)
        ) {
          newErrors[field] = message;
        }
      }
      if (field === "asi_member_certificate") {  
        if (
          !file && applicationId===5
        ) {
          newErrors[field] = message;
        }
      }
      if (field === "mci_certificate") {
        if (!file && eventType === "Update" && memberApplicationId === 4) {
          newErrors[field] = message;
        }
      }
      if (field === "pg_degree_certificate") {
        if (!file && eventType === "Update" && memberApplicationId === 4) {
          newErrors[field] = message;
        }
      }
    };

    // Membership Number validation for specific application IDs
    if ([5, 6].includes(applicationId)) {
      validateField("membership_no", "Membership Number cannot be empty");
    }

    // General Information
    validateField("first_name", "First name cannot be empty");
    // validateField("last_name", "Last name cannot be empty");
    validateField("email", "Email cannot be empty");

    if (formValues.email.trim()) {
      validateRegex("email", /^\S+@\S+\.\S+$/, "Invalid email format");
    }

    validateField("mobile", "Mobile number cannot be empty");
    if (formValues.mobile.trim() && applicationId !== 3 && formValues.mobile_code === "+91") {
      validateRegex("mobile", /^\d{10}$/, "Invalid mobile number format (must be 10 digits)");
    }

    // Additional fields for non-application ID 5
    if (
      applicationId !== 5 ||
      (memberApplicationId === 3 && eventType === "Update")
    ) {
      const fields = [
        // "father_name",
        "dob",
        "age",
        "nationality",
        "street_line1",
        "street_line2",
        "city",
        "pin",
      ];

      fields.forEach((field) =>
        validateField(
          field,
          `${field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase())} cannot be empty`
        )
      );
      validateDropdownField("gender", "Gender cannot be empty");
      validateDropdownField("country", "Country cannot be empty");
      validateDropdownField("state", "State cannot be empty");

      if (formValues.pin.trim()) {
        validateRegex("pin", /^\d{6}$/, "Pin code must be 6 digits");
      }
      if (formValues.age) {
        if (isNaN(formValues.age) || formValues.age <= 0) {
          newErrors.age = "Age must be a valid number";
        }
      }
      // if (formValues.landline.trim() && !formValues.stdcode.trim()) {
      //   newErrors.landline = "STD code cannot be empty";
      // } else if (!formValues.landline.trim() && formValues.stdcode.trim()) {
      //   newErrors.landline = "Landline cannot be empty";
      // }
    }

    // Education fields for specific application IDs
    if ([1, 2, 4, 6].includes(applicationId) && `${formValues.country}` === "101") {
      const eduFields = [
        "edu_undergrad_college",
        "edu_undergrad_university",
        "edu_undergrad_year",
      ];
      eduFields.forEach((field) =>
        validateField(field, `College/Univercity/Year cannot be empty`)
      );
    }

    if (
      applicationId !== 5 ||
      (memberApplicationId === 3 && eventType === "Update")
    ) {
      const postgradFields = [
        "edu_postgrad_degree",
        "edu_postgrad_college",
        "edu_postgrad_university",
        "edu_postgrad_year",
      ];
      postgradFields.forEach((field) =>
        validateField(field, `Degree/College/Univercity/Year cannot be empty`)
      );
    }

    // MCI and ASI fields based on application ID
    if ([1, 6].includes(applicationId) && `${formValues.country}` === "101") {
      validateField("mci_council_number", "NMC council Number cannot be empty");
      validateDropdownField("mci_council_state", "NMC state cannot be empty");
      validateField(
        "asi_membership_no",
        "ASI membership number cannot be empty"
      );
      validateDropdownField("asi_state", "ASI state cannot be empty");
    } else if ([2, 4].includes(applicationId) && `${formValues.country}` === "101") {
      validateField("mci_council_number", "NMC council Number cannot be empty");
      validateDropdownField("mci_council_state", "NMC state cannot be empty");
    } else if (applicationId === 3 || formValues.country !== "101") {
      validateField("mci_council_number", "NMC council Number cannot be empty");
    } else if (
      (applicationId === 5 ||
      (memberApplicationId === 3 && eventType === "Update")) && `${formValues.country}` === "101"
    ) {
      validateField(
        "asi_membership_no",
        "ASI membership number cannot be empty"
      );
      validateDropdownField("asi_state", "ASI state cannot be empty");
    }

    // Document validation based on application ID
    if ([1, 6].includes(applicationId) && `${formValues.country}` === "101") {
      validateFile(
        mciCertificateFile,
        "mci_certificate",
        "NMC certificate cannot be empty"
      );
      validateFile(
        pgDegreeCertificateFile,
        "pg_degree_certificate",
        "PG degree certificate cannot be empty"
      );
      validateFile(
        asiMemberCertificateFile,
        "asi_member_certificate",
        "ASI member certificate cannot be empty"
      );
    } else if (applicationId === 2 && `${formValues.country}` === "101") {
      validateFile(
        mciCertificateFile,
        "mci_certificate",
        "NMC certificate cannot be empty"
      );
      validateFile(
        pgDegreeCertificateFile,
        "pg_degree_certificate",
        "PG degree certificate cannot be empty"
      );
    } else if (applicationId === 3 || `${formValues.country}` !== "101") {
      validateFile(
        activeLicenseFile,
        "active_license",
        "Active license cannot be empty"
      );
      validateFile(
        pgDegreeCertificateFile,
        "pg_degree_certificate",
        "PG degree certificate cannot be empty"
      );
    } else if (applicationId === 4 && `${formValues.country}` === "101") {
      validateFile(hodLetterFile, "letter_hod", "HOD letter cannot be empty");
      validateFile(
        mbbsDegreeCertificateFile,
        "mbbs_degree_certificate",
        "MBBS degree certificate cannot be empty"
      );
    } else if (
      (applicationId === 5 ||
      ([3, 4].includes(memberApplicationId) && eventType === "Update")) && `${formValues.country}` === "101"
    ) {
      validateFile(
        asiMemberCertificateFile,
        "asi_member_certificate",
        "ASI member certificate cannot be empty"
      );
    }

    if ([1, 2, 3, 4, 6].includes(applicationId)) {
      validateFile(profileFile, "profile", "Profile cannot be empty");
    }
    setErrors(newErrors);
    const isClinicAddressValid = validateClinicAddressFields();
    const isProceduresValid = validateProceduresFields();

    const isValid = Object.keys(newErrors).length === 0 && 
                    isClinicAddressValid && 
                    isProceduresValid;

    if (!isValid) {
      // Scroll to first error after state update
      setTimeout(scrollToFirstError, 50);
    }

  return isValid;

    // setErrors(newErrors);
    // const isClinicAddressValid = validateClinicAddressFields();
    // console.log(isClinicAddressValid, "isClinicAddressValid");
    // console.log("ValidateErrors", newErrors);
    // return Object.keys(newErrors).length === 0 && isClinicAddressValid;
  };

  const clearInputValues = () => {
    setErrors({
      profile: "",
      membership_no: "",
      salutation: "",
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      father_name: "",
      dob: "",
      age: "",
      nationality: "",
      gender: "",
      street_line1: "",
      street_line2: "",
      country: "",
      state: "",
      city: "",
      pin: "",
      landline: "",
      stdcode: "",
      mailing_address: "",
      edu_undergrad_degree: "",
      edu_undergrad_college: "",
      edu_undergrad_university: "",
      edu_undergrad_year: "",
      edu_postgrad_degree: "",
      edu_postgrad_college: "",
      edu_postgrad_university: "",
      edu_postgrad_year: "",
      edu_superspecialty_degree: "",
      edu_superspecialty_college: "",
      edu_superspecialty_university: "",
      edu_superspecialty_year: "",
      mci_council_number: "",
      mci_council_state: "",
      imr_reg_no: "",
      asi_membership_no: "",
      asi_state: "",
      other_inter_organisation: "",
      mci_certificate: "",
      pg_degree_certificate: "",
      asi_member_certificate: "",
      active_license: "",
      letter_hod: "",
      mbbs_degree_certificate: "",
    });

    // setImage("../assets/images/user_image.png");
    setProfileFile(null);
    setMciCertificateFile(null);
    setMciCertificateError("");
    setPgDegreeCertificateFile(null);
    setPgDegreeCertificateError("");
    setAsiMemberCertificateFile(null);
    setAsiMemberCertificateError("");
    setActiveLicenseFile(null);
    setActiveLicenseError("");
    setHodLetterFile(null);
    setHodLetterError("");
    setMbbsDegreeCertificateFile(null);
    setMbbsDegreeCertificateError("");

    // setApplicationId(memberApplicationId);

    handleUpdatePopup(false);
  };

  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const addUpdateMembershipApplication = async () => {
    if (validate()) {
      setIsLoadingSubmit(true);
      const updateIds = clinicAddress.map((detail) => detail.id);
      const newClinicName = clinicAddress.map((address) => address.clinic_name);
      const newClinicAddressOne = clinicAddress.map(
        (address) => address.clinic_address_one
      );
      const newClinicAddressTwo = clinicAddress.map(
        (address) => address.clinic_address_two
      );
      const newClinicCountry = clinicAddress.map(
        (address) => address.clinic_country
      );
      const newClinicState = clinicAddress.map(
        (address) => address.clinic_state
      );
      const newClinicCity = clinicAddress.map((address) => address.clinic_city);
      const newClinicPinCode = clinicAddress.map(
        (address) => address.clinic_pin_code
      );
      const newClinicStdCode = clinicAddress.map(
        (address) => address.clinic_stdcode
      );
      const newClinicLandline = clinicAddress.map(
        (address) => address.clinic_landline
      );
      const newClinicMailingAddress = clinicAddress.map(
        (address) => address.clinic_mailing_address
      );

      const clinicAddressIds = updateIds.filter((id) => id !== "");
      const clinicName = newClinicName.filter(
        (clinic_name) => clinic_name.trim() !== ""
      );
      const clinicAddressOne = newClinicAddressOne.filter(
        (clinic_address_one) => clinic_address_one.trim() !== ""
      );
      const clinicAddressTwo = newClinicAddressTwo.filter(
        (clinic_address_two) => clinic_address_two.trim() !== ""
      );
      const clinicCountry = newClinicCountry.filter(
        (clinic_country) => clinic_country !== ""
      );
      const clinicState = newClinicState.filter(
        (clinic_state) => clinic_state !== ""
      );
      const clinicCity = newClinicCity.filter(
        (clinic_city) => clinic_city.trim() !== ""
      );
      const clinicPinCode = newClinicPinCode.filter(
        (clinic_pin_code) => clinic_pin_code.trim() !== ""
      );
      const clinicStdCode = newClinicStdCode.filter(
        (clinic_stdcode) => clinic_stdcode.trim() !== ""
      );
      const clinicLandline = newClinicLandline.filter(
        (clinic_landline) => clinic_landline.trim() !== ""
      );
      const clinicMailingAddress = newClinicMailingAddress.filter(
        (clinic_mailing_address) => clinic_mailing_address !== ""
      );

      const updateProcedureIds = procedures.map((data) => data.id);
      const newWorkProcedure = procedures.map((data) => data.work_procedure);
      const newExpInYear = procedures.map((data) => data.exp_in_year);
      const newNoOfProcedures1 = procedures.map(
        (data) => data.no_of_procedures1
      );
      const newNoOfProcedures2 = procedures.map(
        (data) => data.no_of_procedures2
      );
      const procedureIds = updateProcedureIds.filter((id) => id !== "");
      const workProcedure = newWorkProcedure.filter(
        (work_procedure) => work_procedure.trim() !== ""
      );
      const expInYear = newExpInYear.filter(
        (exp_in_year) => exp_in_year !== ""
      );
      const noOfProcedures1 = newNoOfProcedures1.filter(
        (no_of_procedures1) => no_of_procedures1.trim() !== ""
      );
      const noOfProcedures2 = newNoOfProcedures2.filter(
        (no_of_procedures2) => no_of_procedures2.trim() !== ""
      );

      try {
        const apiEndpoint = `${baseUrl}/api/add_member`;
        const requestData = {
          ...formValues,
          // ...{ application_no: "" },
          ...{ profile: profileFile || "" },
          // ...{ application_id: applicationId || "" },changeApplicationId
          ...{ application_id: applicationId || "" },
          // ...{ clinic_name: clinicName.length > 0 ? clinicName : "" },
          // ...{
          //   clinic_address_one:
          //     clinicAddressOne.length > 0 ? clinicAddressOne : "",
          // },
          // ...{
          //   clinic_address_two:
          //     clinicAddressTwo.length > 0 ? clinicAddressTwo : "",
          // },
          // ...{ clinic_country: clinicCountry.length > 0 ? clinicCountry : "" },
          // ...{ clinic_state: clinicState.length > 0 ? clinicState : "" },
          // ...{ clinic_city: clinicCity.length > 0 ? clinicCity : "" },
          // ...{ clinic_pin_code: clinicPinCode.length > 0 ? clinicPinCode : "" },
          // ...{ clinic_stdcode: clinicStdCode.length > 0 ? clinicStdCode : "" },
          // ...{
          //   clinic_landline: clinicLandline.length > 0 ? clinicLandline : "",
          // },
          // ...{
          //   clinic_mailing_address:
          //     clinicMailingAddress.length > 0
          //       ? clinicMailingAddress
          //       : "",
          // },
          ...{ clinic_name: newClinicName.length > 0 ? newClinicName : "" },
          ...{
            clinic_address_one:
              newClinicAddressOne.length > 0 ? newClinicAddressOne : "",
          },
          ...{
            clinic_address_two:
              newClinicAddressTwo.length > 0 ? newClinicAddressTwo : "",
          },
          ...{
            clinic_country: newClinicCountry.length > 0 ? newClinicCountry : "",
          },
          ...{ clinic_state: newClinicState.length > 0 ? newClinicState : "" },
          ...{ clinic_city: newClinicCity.length > 0 ? newClinicCity : "" },
          ...{
            clinic_pin_code:
              newClinicPinCode.length > 0 ? newClinicPinCode : "",
          },
          ...{
            clinic_stdcode: newClinicStdCode.length > 0 ? newClinicStdCode : "",
          },
          ...{
            clinic_landline:
              newClinicLandline.length > 0 ? newClinicLandline : "",
          },
          ...{
            clinic_mailing_address:
              newClinicMailingAddress.length > 0 ? newClinicMailingAddress : "",
          },
          // ...{
          //   clinic_mailing_address:
          //     clinicMailingAddress.length > 0 && clinicName.length > 0
          //       ? clinicMailingAddress
          //       : "",
          // },

          // ...{ work_procedure: workProcedure.length > 0 ? workProcedure : "" },
          // ...{ exp_in_year: expInYear.length > 0 ? expInYear : "" },
          // ...{
          //   no_of_procedures1:
          //     noOfProcedures1.length > 0 ? noOfProcedures1 : "",
          // },
          // ...{
          //   no_of_procedures2:
          //     noOfProcedures2.length > 0 ? noOfProcedures2 : "",
          // },
          ...{
            work_procedure: newWorkProcedure.length > 0 ? newWorkProcedure : "",
          },
          ...{ exp_in_year: newExpInYear.length > 0 ? newExpInYear : "" },
          ...{
            no_of_procedures1:
              newNoOfProcedures1.length > 0 ? newNoOfProcedures1 : "",
          },
          ...{
            no_of_procedures2:
              newNoOfProcedures2.length > 0 ? newNoOfProcedures2 : "",
          },

          ...{ mci_certificate: mciCertificateFile || "" },
          ...{ pg_degree_certificate: pgDegreeCertificateFile || "" },
          ...{ asi_member_certificate: asiMemberCertificateFile || "" },
          ...{ active_license: activeLicenseFile || "" },
          ...{ letter_hod: hodLetterFile || "" },
          ...{ mbbs_degree_certificate: mbbsDegreeCertificateFile || "" },
          ...{
            other_inter_organisation:
              `${formValues.other_inter_organisation}` || "",
          },
          ...(eventType === "Update" && {
            id: memberId,
            clinic_id: clinicAddressIds.length > 0 ? clinicAddressIds : "",
            work_exp_id: procedureIds.length > 0 ? procedureIds : "",
          }),
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(apiEndpoint, requestData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-Source": "web",
            Authorization: localStorage.getItem("access_token"),
          },
        });
        if (response.data.status) {
          showToast(response.data.message, "success");
          console.log(response.data, "response.data");
          fetchPreviewMemberDetailsData();
          clearInputValues();
        } else {
          showToast(response.data.message, "error");
        }
      } 
      catch (err) {
        console.error("Error in InsertMembersPersonal:", err);
    
        let message = "A network error occurred. Please try again later.";
    
        if (err.response) {
          // Server returned error (400, 500, etc.)
          message =
            err.response.data?.message ||
            err.response.data?.error ||
            `Server error (${err.response.status})`;
        } else if (err.request) {
          // Request was made but no response
          message = "No response from server. Please check your internet connection.";
        } else {
          // Something else went wrong
          message = err.message || "Request failed";
        }
    
        // throw new Error(message);
        showToast(message, "error");
      }
      // catch (error) {
      //   console.error("Error during submission:", error);
      //   showToast("A network error occurred, or the server is temporarily busy. Please try again later.", "error");
      // }
      finally {
      setIsLoadingSubmit(false);
    }
    } else {
      showToast("Please fill in the required details.", "error");
    }
  };

  const [countryData, setCountryData] = useState([]);
  // console.log(countryData, "countryData");
  const fetchCountryData = async () => {
    console.log(`${baseUrl}/api/get_country`);
    try {
      const response = await axios.get(`${baseUrl}/api/get_country`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });

      if (response.data.status) {
        setCountryData(response.data.data);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const [stateData, setStateData] = useState([]);
  const [asiMciStateData, setAsiMciStateData] = useState([]);
  const fetchStateData = async (countryId) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/get_state`,
        { id: countryId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.status) {
        return response.data.data;
      } else {
        console.error("Error: Failed to fetch state data");
        return [];
      }
    } catch (error) {
      console.error("Error fetching state data:", error);
      return [];
    }
  };

  // const fetchStateData = async (countryId) => {
  //   try {
  //     const response = await axios.post(
  //       `${baseUrl}/api/get_state`,
  //       {
  //         id:countryId
  //       },
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           Authorization: localStorage.getItem('access_token'),
  //         },
  //       }
  //     );

  //     if (response.data.status) {
  //       setStateData(response.data.data);
  //     } else {
  //       console.error('Error: Failed to fetch user data');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching users data:', error);
  //   }
  // };

  useEffect(() => {
    // Function to fetch states based on country
    const fetchStates = async (countryId) => {
      return await fetchStateData(countryId);
    };

    const getStatesForAllClinics = async () => {
      if (formValues.country) {
        const states = await fetchStates(formValues.country);
        setStateData(states);
        setAsiMciStateData(states);
      } else {
        setStateData([]);
      }

      const clinicStatesData = await Promise.all(
        clinicAddress.map(async (address, index) => {
          if (address.clinic_country) {
            return await fetchStates(address.clinic_country);
          }
          return [];
        })
      );
      setClinicStateData(clinicStatesData);
    };

    getStatesForAllClinics();
  }, [formValues.country, clinicAddress]);

  useEffect(() => {
    if (memberApplicationId === 3) {
      formValues.country = "";
      formValues.nationality = "";
    }
    setApplicationId(memberApplicationId);
    // if (applicationId===3||applicationId===4){
    //   setChangeApplicationId(applicationId);
    // }
  }, [memberApplicationId, countryData]);

  // useEffect(() => {
  //   const loadStateData = async () => {
  //     const data = await fetchStateData(101);
  //     console.log(data, "msi");

  //     setAsiMciStateData(data);
  //   };

  //   loadStateData();
  // }, []);

  useEffect(() => {
    fetchCountryData();
  }, []);

  // const[updateProfile,setUpdateProfile]=useState("");
  const [memberDetails, setMemberDetails] = useState({});
  const fetchMemberDetailsData = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/member_detail`,
        { id: memberId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        const details = response.data.data[0];
        console.log(details, "details");

        setMemberDetails(details);
        setFormValues({
          application_no: details.application_no || "",
          membership_no: details.membership_no || "",
          salutation: details.salutation || "",
          first_name: details.first_name || "",
          last_name: details.last_name || "",
          middle_name: details.middle_name || "",
          email: details.email || "",
          mobile: details.mobile || "",
          mobile_code: details.mobile_code || "",
          father_name: details.father_name || "",
          dob: details.dob || "",
          age: String(details.age) || "",
          nationality: details.nationality || "",
          gender: details.gender || "",
          zone: details.zone || "",
          street_line1: details.street_line1 || "",
          street_line2: details.street_line2 || "",
          country: details.country || "",
          state: details.state || "",
          city: details.city || "",
          pin: details.pin || "",
          landline: details.landline || "",
          stdcode: details.stdcode || "",
          mailing_address: details.mailing_address,
          edu_undergrad_degree: details.edu_undergrad_degree || "",
          edu_undergrad_college: details.edu_undergrad_college || "",
          edu_undergrad_university: details.edu_undergrad_university || "",
          edu_undergrad_year: String(details.edu_undergrad_year) || "",
          edu_postgrad_degree: details.edu_postgrad_degree || "",
          edu_postgrad_college: details.edu_postgrad_college || "",
          edu_postgrad_university: details.edu_postgrad_university || "",
          edu_postgrad_year: String(details.edu_postgrad_year) || "",
          edu_superspecialty_degree: details.edu_superspecialty_degree || "",
          edu_superspecialty_college: details.edu_superspecialty_college || "",
          edu_superspecialty_university:
            details.edu_superspecialty_university || "",
          edu_superspecialty_year:
            String(details.edu_superspecialty_year) || "",
          mci_council_number: details.mci_council_number || "",
          mci_council_state: details.mci_council_state || "",
          imr_reg_no: details.imr_reg_no || "",
          asi_membership_no: details.asi_membership_no || "",
          asi_state: details.asi_state || "",
          other_inter_organisation: details.other_inter_organisation
            ? details.other_inter_organisation.split(",").filter(Boolean)
            : [],
          other_inter_organisation_value:
            details.other_inter_organisation_value || "",
        });
        if (response.data.clinic.length > 0) {
          const clinicData = response.data.clinic.map((item) => ({
            id: item.id,
            clinic_name: item.clinic_name,
            clinic_address_one: item.clinic_address_one,
            clinic_address_two: item.clinic_address_two,
            clinic_country: item.clinic_country,
            clinic_state: item.clinic_state,
            clinic_city: item.clinic_city,
            clinic_pin_code: item.clinic_pin_code,
            clinic_landline: item.clinic_landline,
            clinic_stdcode: item.clinic_stdcode,
            clinic_mailing_address: item.clinic_mailing_address,
          }));
          setClinicAddress(clinicData);
        }
        if (response.data.work_exp.length > 0) {
          const proceduresData = response.data.work_exp.map((item) => ({
            id: item.id,
            work_procedure: item.work_procedure,
            exp_in_year: String(item.exp_in_year),
            no_of_procedures1: item.no_of_procedures1,
            no_of_procedures2: item.no_of_procedures2,
          }));
          setProcedures(proceduresData);
        }
        // setUpdateDropDownValues(response.data.data)
        // setStateData(response.data.data)
        console.log(response.data, "fetchMemberDetailsData");
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const [membershipPackageData, setMembershipPackageData] = useState([]);

  const fetchMembershipPackageData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_application`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });

      if (response.data.status) {
        setMembershipPackageData(response.data.data);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const filterActions = (id) => {
    if (id === 2) return [2, 5];
    if (id === 4) return [4, 6];
    return [];
  };

  useEffect(() => {
    if (eventType === "Update") {
      fetchMembershipPackageData();
      fetchMemberDetailsData();
    }
  }, [eventType, addPopupStatus]);

  const [searchTerm, setSearchTerm] = useState("");

  const filteredStateData = stateData.filter((data) =>
    data.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const [phoneNumber, setPhoneNumber] = useState("");

  // const handleMobileChange = (value) => {
  //   // setPhoneNumber(value);
  //   console.log(value,"mobile");
  //   setFormValues({
  //     ...formValues,
  //     mobile: value,
  //     mobile_code:value 
  //   });
  // };
  const handleMobileChange = (value) => {
    if (value) {
      const phoneNumber = parsePhoneNumberFromString(value);
      if (phoneNumber) {
        const countryCode = `+${phoneNumber.countryCallingCode}`; // Extract country code
        const mobileNumber = phoneNumber.nationalNumber; // Extract only the national number

        console.log(mobileNumber, "mobile"); // Expected: 8925182585
        console.log(countryCode, "country code"); // Expected: +91

        setFormValues({
          ...formValues,
          mobile: mobileNumber, // Only national number
          mobile_code: countryCode, // Country code separately
        });
        return;
      }
    }

    // Reset if invalid or empty
    setFormValues({
      ...formValues,
      mobile: "",
      mobile_code: "",
    });
  };
  const handleStateChange = (value) => {
    const selectedStateId = Number(value);
    console.log(selectedStateId, "Selected State ID");

    setFormValues((prevState) => ({
      ...prevState,
      state: value,
    }));

    console.log(stateData, "stateData Array");

    const selectedState = stateData.find(
      (state) => state.id === selectedStateId
    );
    console.log(selectedState, "Selected State");

    if (selectedState) {
      console.log(selectedState.name, "State Name from stateData");

      const foundZone = AllzoneData.find((zone) => {
        return (
          Array.isArray(zone.states) && zone.states.includes(selectedState.name)
        );
      });

      console.log(foundZone, "Found Zone");

      if (foundZone) {
        setFormValues((prevState) => ({
          ...prevState,
          zone: foundZone.value,
        }));
      } else {
        setFormValues((prevState) => ({
          ...prevState,
          zone: "",
        }));
      }
    } else {
      console.log("State not found in stateData array");
      setFormValues((prevState) => ({
        ...prevState,
        zone: "",
      }));
    }
  };
  const handleCountryChange = (value) => {
    const selectedCountryId = Number(value);
    console.log(selectedCountryId, "Selected Country ID");
    setFormValues((prevState) => ({
      ...prevState,
      country: value,
    }));
    console.log(countryData, "countryData Array");

    const selectedCountry = countryData.find(
      (country) => country.id === selectedCountryId
    );
    console.log(selectedCountry, "Selected Courntry");

    if (selectedCountry) {
      console.log(selectedCountry.nationality, "Country Name from countryData");
      setFormValues((prevState) => ({
        ...prevState,
        nationality: selectedCountry.nationality,
      }));
    }else{
      if(selectedCountryId !== 101){
      setFormValues((prevState) => ({
        ...prevState,
        nationality: "",
      }));
     }
    } 
  };

  const workExpInYears = (from, to) => {
    const year1 = new Date(from).getFullYear();
    const year2 = new Date(to).getFullYear();
    return year2 - year1;
  };

  return (
    <>
      <ToastMessage />
      {addPopupStatus && (
        <div
          className={`extraspace_search_div search_div${addPopupStatus ? " open" : ""
            }`}
        >
          <div className="card member_master_sidebar_scrool">
            <div className="member_edit_pop_flex mb-3 text-end">
              <h3>{eventType} Application</h3>
              <div className="input-group-append">
                <span
                  onClick={() => clearInputValues()}
                  className="search_toggle btn btn-danger"
                >
                  <i className="fa fa-times" />
                </span>
              </div>
            </div>
            <div className="table-responsive">
              <div className="body  application_body_side">
                <fieldset>
                  <div className="row clearfix">
                    {([1, 2, 3, 4, 6].includes(applicationId) ||
                      (memberApplicationId === 2 &&
                        eventType === "Update")) && (
                        <div className="col-lg-6 col-md-12 pos_relative">
                          <label>
                            Upload Image <span className="text-danger">*</span>
                          </label>
                          <p style={{ margin: "0" }} />
                          <div className="pos_re">
                            <img
                              src={
                                eventType === "Update" && !profileFile
                                  ? `${memberDetails.profile}`
                                  : image
                              }
                              width="80"
                              height="80"
                              className="img-thumbnail rounded-circle width_profile_image"
                              alt="person"
                              onClick={handleImageClick}
                              style={{ cursor: "pointer" }}
                            />
                            <i
                              onClick={handleImageClick}
                              className="fa fa-pencil upload_image_edit_icon"
                            />
                            <input
                              type="file"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              accept=".png,.jpg,.jpeg,.webp,.svg"
                              onChange={handleFileChange}
                            />
                          </div>
                          {errors && (
                            // <p className="text-danger pos_abos left_15">
                            //   {errors.profile}
                            // </p>                       
                            <input
                              disabled
                              name="profile"
                              type="text"
                              className={`form-group pos_abos left_15 ${
                                errors.profile ? " red_border text-danger" : ""
                              }`}
                              value={errors.profile}
                              hidden={errors.profile ? false: true}
                            />
                          )}
                        </div>
                      )}
                    {/* {[5, 6].includes(applicationId) || ([3,4].includes(applicationId)&&eventType==="Update") && ( */}
                    {([5, 6].includes(applicationId) ||
                      (memberApplicationId === 2 &&
                        eventType === "Update" &&
                        formValues.membership_no)) && (
                        <div className="col-md-6">
                          <div className="form-group pos_relative">
                            <label>
                              Membership Number{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="number"
                              className={`form-control ${errors.membership_no ? "red_border" : ""
                                }`}
                              value={formValues.membership_no}
                              onChange={(e) =>
                                handleInputChange("membership_no", e.target.value)
                              }
                              disabled={eventType === "Update"}
                            />
                            {errors && (
                              <p className="text-danger pos_abos">
                                {errors.membership_no}
                              </p>
                            )}
                          </div>
                        </div>
                      )}
                        <div className="col-md-6">
                            <div className="form-group pos_relative">
                              <label>
                                Name Salutation{" "}
                              </label>
                              <select
                                className={`multiselect multiselect-custom form-control cursor-pointer`}
                                value={formValues.salutation}
                                onChange={(e) =>
                                  handleInputChange(
                                    "salutation",
                                    e.target.value
                                  )
                                }
                                displayEmpty
                              >
                                <option
                                  style={{ cursor: "pointer" }}
                                  value=""
                                >
                                  --Select a Name Salutation--
                                </option>
                                {salutationData.map((data) => (
                                  <option
                                    style={{ cursor: "pointer" }}
                                    key={data.id}
                                    value={data.value}
                                  >
                                    {data.value}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div> 
                    <div className="col-md-6">
                      <div className="form-group pos_relative">
                        <label>
                          First Name 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.first_name ? "red_border" : ""
                            }`}
                          value={formValues.first_name}
                          onChange={(e) => {
                            let input = e.target.value;
                            input = input.replace(/[^A-Za-z]/g, "");
                            handleInputChange("first_name", input);
                          }}
                          disabled={eventType === "Update"}
                        />
                        <small>(Only alphabetic characters are allowed.)</small>
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.first_name}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group pos_relative">
                        <label>
                          Middle Name 
                        </label>
                        <input
                          type="text"
                          className={`form-control`}
                          value={formValues.middle_name}
                          onChange={(e) => {
                            let input = e.target.value;
                            input = input.replace(/[^A-Za-z]/g, "");
                            handleInputChange("middle_name", input);
                          }}
                        />
                        <small>(Only alphabetic characters are allowed.)</small>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group pos_relative">
                        <label>
                          Last Name 
                        </label>
                        <input
                          type="text"
                          className={`form-control`}
                          value={formValues.last_name}
                          onChange={(e) => {
                            let input = e.target.value;
                            input = input.replace(/[^A-Za-z]/g, "");
                            handleInputChange("last_name", input);
                          }}
                        />
                        <small>(Only alphabetic characters are allowed.)</small>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group pos_relative">
                        <label>
                          Email Id 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <input
                          type="email"
                          className={`form-control ${errors.email ? "red_border" : ""
                            }`}
                          value={formValues.email}
                          onChange={(e) =>
                            handleInputChange("email", e.target.value)
                          }
                          disabled={eventType === "Update"}
                        />
                        {errors && (
                          <p className="text-danger pos_abos">{errors.email}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group pos_relative">
                        <label>
                          Mobile Number{phoneNumber}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <ReactPhoneInput
                            defaultCountry={applicationId !== 3 && "IN"}
                            // value={formValues.mobile}
                            value={formValues.mobile ? `+${formValues.mobile_code.replace("+", "")}${formValues.mobile}` : ""}
                            // onChange={(e) =>
                            //   handleInputChange("mobile", e.target.value)
                            // }
                            // value={phoneNumber}
                            onChange={handleMobileChange}
                            international
                            withCountryCallingCode
                            className={`custom-phone-input form-control ${errors.mobile ? "red_border" : ""
                              }`}
                            placeholder="Enter your mobile number"
                          // disabled={eventType === "Update"}
                          />
                        </div>
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.mobile}
                          </p>
                        )}
                      </div>
                    </div>
                    {([1, 2, 3, 4, 6].includes(applicationId) ||
                      (memberApplicationId === 2 &&
                        eventType === "Update")) && (
                        <>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group pos_relative">
                              <label>
                                Father's Name{" "}
                                {/* <span className="text-danger">*</span> */}
                              </label>
                              <input
                                type="text"
                                className={`form-control`}
                                value={formValues.father_name}
                                onChange={(e) =>
                                  handleInputChange("father_name", e.target.value)
                                }
                              />
                              {/* {errors && (
                                <p className="text-danger pos_abos">
                                  {errors.father_name}
                                </p>
                              )} */}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group pos_relative date_picker_div">
                              <label>
                                Date of Birth{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <Datepicker
                                selectedDate={formValues.dob ? new Date(formValues.dob) : null}
                                onDateChange={(date) => {
                                  const newDob = date ? dayjs(date).format(dateFormatList) : ""
                                  const newAge = calculateAge(newDob)
                                  setFormValues((prev) => ({
                                    ...prev,
                                    dob: newDob,
                                    age: newAge,
                                  }))
                                }}
                                className={`form-control ${errors.dob ? "red_border" : ""}`}
                                placeholder="DD/MM/YYYY"
                              />
                              {errors?.dob && (
                                <p className="text-danger pos_abos">
                                  {errors.dob}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group pos_relative">
                              <label>
                                Age 
                                {/* <span className="text-danger">*</span> */}
                              </label>
                              <input
                                type="number"
                                className={`form-control ${errors.age ? "red_border" : ""
                                  }`}
                                value={formValues.age}
                                disabled
                                // readOnly
                              />
                              {errors?.age && (
                                <p className="text-danger pos_abos">
                                  {errors.age}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-6 col-md-12 personal_details_dropdown">
                            <div className="form-group pos_relative">
                              <label>
                                Nationality <span className="text-danger">*</span>
                              </label>
                              <input
                              type="text"
                              value={formValues.nationality}
                              className="form-control"
                              disabled
                              // readOnly
                            />
                              {/* <div className="multiselect_div">
                                <CustomDropdown
                                  dropdownData={countryData}
                                  ShouldValidate={true}
                                  dropdownValue={formValues.nationality}
                                  setDropdownValue={(value) =>
                                    handleInputChange("nationality", value)
                                  }
                                  disabled={applicationId !== 3}
                                  name="nationality"
                                  DataRefechRetrigger={DataRefechRetrigger}
                                  fieldName="nationality"
                                  errors={errors}
                                  formValues={formValues}
                                  eventType={
                                    eventType === "Update" ? "Update" : "Add"
                                  }
                                  applicationId={applicationId}
                                  FeildName={"nationality"}
                                />
                              </div> */}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group pos_relative">
                              <label>
                                Gender <span className="text-danger">*</span>
                              </label>
                              <select
                                className={`multiselect multiselect-custom form-control cursor-pointer ${errors.gender ? "red_border" : ""
                                  }`}
                                value={formValues.gender}
                                onChange={(e) =>
                                  handleInputChange("gender", e.target.value)
                                }
                                displayEmpty
                              >
                                <option style={{ cursor: "pointer" }} value="">
                                  -- Select Gender Type--
                                </option>
                                {genderData.map((data) => (
                                  <option
                                    style={{ cursor: "pointer" }}
                                    key={data.id}
                                    value={data.value}
                                  >
                                    {data.value}
                                  </option>
                                ))}
                              </select>
                              {errors && (
                                <p className="text-danger pos_abos">
                                  {errors.gender}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="header">
                              <h2>Permanent Address</h2>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group pos_relative">
                              <label>
                                Street line 1{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control ${errors.street_line1 ? "red_border" : ""
                                  }`}
                                value={formValues.street_line1}
                                onChange={(e) =>
                                  handleInputChange(
                                    "street_line1",
                                    e.target.value
                                  )
                                }
                              />
                              {errors && (
                                <p className="text-danger pos_abos">
                                  {errors.street_line1}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group pos_relative">
                              <label>
                                Street line 2{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control ${errors.street_line2 ? "red_border" : ""
                                  }`}
                                value={formValues.street_line2}
                                onChange={(e) =>
                                  handleInputChange(
                                    "street_line2",
                                    e.target.value
                                  )
                                }
                              />
                              {errors && (
                                <p className="text-danger pos_abos">
                                  {errors.street_line2}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12 personal_details_dropdown">
                            <div className="form-group pos_relative">
                              <label>
                                Country <span className="text-danger">*</span>
                              </label>
                              <div className="multiselect_div">
                              <CustomDropdown
                                dropdownData={countryData}
                                dropdownValue={formValues.country}
                                ShouldValidate={true}
                                setDropdownValue={handleCountryChange}
                                // setDropdownValue={(value) => handleInputChange("country", value)}
                                // disabled={applicationId !== 3}
                                applicationId={applicationId}
                                name="country name"
                                DataRefechRetrigger={DataRefechRetrigger}
                                fieldName="country"
                                errors={errors}
                                formValues={formValues}
                                eventType={eventType === "Update" ? "Update" : "Add"}
                                FeildName={"country"}
                              />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12 personal_details_dropdown">
                            <div className="form-group pos_relative">
                              <label>
                                State <span className="text-danger">*</span>
                              </label>
                              <CustomDropdown
                                dropdownData={stateData}
                                dropdownValue={formValues.state}
                                setDropdownValue={handleStateChange}
                                name="State"
                                DataRefechRetrigger={DataRefechRetrigger}
                                fieldName="state"
                                errors={errors}
                                formValues={formValues}
                                ShouldValidate={true}
                                eventType={
                                  eventType === "Update" ? "Update" : "Add"
                                }
                                FeildName={"state"}
                              />
                            </div>
                          </div>
                          {applicationId !== 3 &&
                          <div className="col-md-6">
                            <div className="form-group pos_relative">
                              <label>Your Zone</label>
                              <input
                                type="text"
                                value={formValues.zone}
                                className="form-control"
                                disabled={
                                  applicationId === 3 ||
                                  !formValues.state ||
                                  formValues.state.length === 0
                                }
                                readOnly
                              />
                            </div>
                          </div>}
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group pos_relative">
                              <label>
                                City / District{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control ${errors.city ? "red_border" : ""
                                  }`}
                                value={formValues.city}
                                onChange={(e) => {
                                  let input = e.target.value
                                  input = input.replace(/[^A-Za-z ]/g, "");
                                  handleInputChange("city", input)
                                }}
                                // onChange={(e) =>
                                //   handleInputChange("city", e.target.value)
                                // }
                              />
                              {errors && (
                                <p className="text-danger pos_abos">
                                  {errors.city}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group pos_relative">
                              <label>
                                Postal / Zip Code{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="number"
                                className={`form-control ${errors.pin ? "red_border" : ""
                                  }`}
                                value={formValues.pin}
                                onChange={(e) =>
                                  handleInputChange("pin", e.target.value)
                                }
                              />
                              {errors && (
                                <p className="text-danger pos_abos">
                                  {errors.pin}
                                </p>
                              )}
                              <small>
                                (Please enter numbers only.)
                              </small>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group pos_relative">
                              <label>Landline</label>
                              <div className="landline_d_flex">
                                <input
                                  type="number"
                                  style={{ width: "30%" }}
                                  className="form-control"
                                  // className={`form-control ${errors.stdcode ? 'red_border' : ''}`}
                                  value={formValues.stdcode}
                                  placeholder="STD"
                                  onChange={(e) =>
                                    handleInputChange("stdcode", e.target.value)
                                  }
                                />
                                {/* {errors &&
                        <p className="text-danger pos_abos">{errors.stdcode}</p>} */}
                                <input
                                  type="number"
                                  className={`form-control ${errors.landline ? "red_border" : ""
                                    }`}
                                  value={formValues.landline}
                                  onChange={(e) =>
                                    handleInputChange("landline", e.target.value)
                                  }
                                />
                                {errors && (
                                  <p className="text-danger pos_abos">
                                    {errors.landline}
                                  </p>
                                )}
                              </div>
                              <small>
                               (Please enter numbers only.)
                              </small>                             
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="text-right">
                              <label>
                                <FormCheck
                                  type="checkbox"
                                  id={`checkbox-permanent`}
                                  label="Use this as mailing address"
                                  checked={
                                    formValues.mailing_address === 1
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    // If this checkbox is being checked
                                    if (e.target.checked) {
                                      // Set permanent address as mailing address
                                      handleInputChange("mailing_address", 1)
  
                                      // Uncheck all clinic address mailing checkboxes
                                      const updatedClinicAddress = clinicAddress.map((address) => ({
                                        ...address,
                                        clinic_mailing_address: 0,
                                      }))
                                      setClinicAddress(updatedClinicAddress)
                                    } else {
                                      // Just uncheck this checkbox
                                      handleInputChange("mailing_address", 0)
                                    }
                                  }}
                                />
                                {/* <span>Use this as mailing address</span> */}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="header client_d-flex">
                              <h2>Clinic / Hospital Address</h2>
                            </div>
                          </div>
                          {clinicAddress?.map((data, index) => (
                            <>
                              <div className="col-lg-6 col-md-12">
                                <div className="form-group pos_relative">
                                  <label>Clinic Name</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    // className={`form-control ${clinicAddressErrors[`clinic_name-${index}`] ? 'red_border' : ''}`}
                                    value={data.clinic_name}
                                    onChange={(e) =>
                                      handleClinicAddressChange(
                                        index,
                                        "clinic_name",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-12">
                                <div className="form-group pos_relative">
                                  <label>Street line 1</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={data.clinic_address_one}
                                    onChange={(e) =>
                                      handleClinicAddressChange(
                                        index,
                                        "clinic_address_one",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </div>

                              <div className="col-lg-6 col-md-12">
                                <div className="form-group pos_relative">
                                  <label>Street line 2</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={data.clinic_address_two}
                                    onChange={(e) =>
                                      handleClinicAddressChange(
                                        index,
                                        "clinic_address_two",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </div>

                              <div className="col-lg-6 col-md-12">
                                <div className="form-group pos_relative">
                                  <label>Country</label>
                                  <CustomDropdown
                                    dropdownData={countryData}
                                    ShouldValidate={true}
                                    dropdownValue={
                                      clinicAddress[index].clinic_country
                                    }
                                    setDropdownValue={(value) =>
                                      handleClinicAddressChange(
                                        index,
                                        "clinic_country",
                                        value
                                      )
                                    }
                                    DataRefechRetrigger={DataRefechRetrigger}
                                    name="country"
                                    fieldName="clinic_country"
                                    errors={errors}
                                    formValues={formValues}
                                    eventType={
                                      eventType === "Update" ? "Update" : "Add"
                                    }
                                    FeildName={"clinic_country"}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-6 col-md-12">
                                <div className="form-group pos_relative">
                                  <label>State</label>
                                  <CustomDropdown
                                    dropdownData={clinicStateData[index] || []} // use the state data for the specific index
                                    dropdownValue={data.clinic_state}
                                    setDropdownValue={(value) =>
                                      handleClinicAddressChange(
                                        index,
                                        "clinic_state",
                                        value
                                      )
                                    }
                                    ShouldValidate={false}
                                    name="state"
                                    fieldName="clinic_state"
                                    errors={errors}
                                    formValues={formValues}
                                    disabled={!data.clinic_country}
                                    eventType={
                                      eventType === "Update" ? "Update" : "Add"
                                    }
                                    FeildName={"clinic_state"}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-6 col-md-12">
                                <div className="form-group pos_relative">
                                  <label>City / District</label>
                                  <input
                                    type="text"
                                    className={`form-control ${clinicAddressErrors[`clinic_city-${index}`]
                                      ? "red_border"
                                      : ""
                                      }`}
                                    value={data.clinic_city}
                                    onChange={(e) =>
                                      handleClinicAddressChange(
                                        index,
                                        "clinic_city",
                                        e.target.value
                                      )
                                    }
                                  />
                                  {clinicAddressErrors[
                                    `clinic_city-${index}`
                                  ] && (
                                      <p className="text-danger pos_abos">
                                        {
                                          clinicAddressErrors[
                                          `clinic_city-${index}`
                                          ]
                                        }
                                      </p>
                                    )}
                                </div>
                              </div>

                              <div className="col-lg-6 col-md-12">
                                <div className="form-group pos_relative">
                                  <label>Postal / Zip Code</label>
                                  <input
                                    type="number"
                                    className={`form-control ${clinicAddressErrors[
                                      `clinic_pin_code-${index}`
                                    ]
                                      ? "red_border"
                                      : ""
                                      }`}
                                    value={data.clinic_pin_code}
                                    onChange={(e) =>
                                      handleClinicAddressChange(
                                        index,
                                        "clinic_pin_code",
                                        e.target.value
                                      )
                                    }
                                  />
                                  <small>
                                      (Please enter numbers only.)
                                  </small>
                                  {clinicAddressErrors[
                                    `clinic_pin_code-${index}`
                                  ] && (
                                      <p className="text-danger pos_abos">
                                        {
                                          clinicAddressErrors[
                                          `clinic_pin_code-${index}`
                                          ]
                                        }
                                      </p>
                                    )}
                                </div>
                              </div>

                              <div className="col-lg-6 col-md-12">
                                <div className="form-group pos_relative">
                                  <label>Landline</label>
                                  <div className="landline_d_flex">
                                    <input
                                      type="number"
                                      style={{ width: "30%" }}
                                      className="form-control"
                                      // className={`form-control ${clinicAddressErrors[`clinic_stdcode-${index}`] ? 'red_border' : ''}`}
                                      value={data.clinic_stdcode}
                                      placeholder="STD"
                                      onChange={(e) =>
                                        handleClinicAddressChange(
                                          index,
                                          "clinic_stdcode",
                                          e.target.value
                                        )
                                      }
                                    />
                                    <input
                                      type="number"
                                      className={`form-control ${clinicAddressErrors[
                                        `clinic_landline-${index}`
                                      ]
                                        ? "red_border"
                                        : ""
                                        }`}
                                      value={data.clinic_landline}
                                      onChange={(e) =>
                                        handleClinicAddressChange(
                                          index,
                                          "clinic_landline",
                                          e.target.value
                                        )
                                      }
                                    />
                                    {clinicAddressErrors[
                                      `clinic_landline-${index}`
                                    ] && (
                                        <p className="text-danger pos_abos">
                                          {
                                            clinicAddressErrors[
                                            `clinic_landline-${index}`
                                            ]
                                          }
                                        </p>
                                      )}
                                  </div>
                                  <small>
                                      (Please enter numbers only.)
                                  </small>                                  
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="text-right">
                                  <label>
                                    <FormCheck
                                      disabled={!data.clinic_name}
                                      id={`checkbox-clinic-${index}`}
                                      type="checkbox"
                                      label="Use this as mailing address"
                                      checked={
                                        data.clinic_mailing_address === 1
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        // If this checkbox is being checked
                                        if (e.target.checked) {
                                          // First, set all clinic addresses mailing to 0
                                          const updatedClinicAddress = clinicAddress.map((addr) => ({
                                            ...addr,
                                            clinic_mailing_address: 0,
                                          }))
  
                                          // Then set only this one to 1
                                          updatedClinicAddress[index].clinic_mailing_address = 1
                                          setClinicAddress(updatedClinicAddress)
  
                                          // Uncheck the permanent address mailing checkbox
                                          handleInputChange("mailing_address", 0)
                                        } else {
                                          // Just uncheck this checkbox
                                          handleClinicAddressChange(index, "clinic_mailing_address", 0)
                                        }
                                      }}
                                    />
                                  </label>
                                </div>
                              </div>
                            </>
                          ))}
                        </>
                      )}
                    <div className="col-md-12">
                      <div className="header">
                        <h2>Education & Practice </h2>
                      </div>
                    </div>
                    {([1, 2, 4, 6].includes(applicationId) && `${formValues.country}`==="101" ) && (
                      <>
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-lg-3 col-md-12">
                              <div className="form-group pos_relative">
                                <label>
                                  Under Graduation{" "}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6 ">
                              <div className="row">
                                <div className="col-lg-6 col-md-12">
                                  <div className="form-group pos_relative">
                                    <input
                                      type="text"
                                      className={`form-control ${errors.edu_undergrad_college
                                        ? "red_border"
                                        : ""
                                        }`}
                                      value={formValues.edu_undergrad_college}
                                      placeholder="College"
                                      onChange={(e) =>
                                        handleInputChange(
                                          "edu_undergrad_college",
                                          e.target.value
                                        )
                                      }
                                    />
                                    {errors && (
                                      <p className="text-danger pos_abos white_space">
                                        {errors.edu_undergrad_college}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                  <div className="form-group pos_relative">
                                    <input
                                      type="text"
                                      className={`form-control ${errors.edu_undergrad_university
                                        ? "red_border"
                                        : ""
                                        }`}
                                      value={
                                        formValues.edu_undergrad_university
                                      }
                                      placeholder="University"
                                      onChange={(e) =>
                                        handleInputChange(
                                          "edu_undergrad_university",
                                          e.target.value
                                        )
                                      }
                                    />
                                    {/* {errors &&
                                <p className="text-danger pos_abos">{errors.edu_undergrad_university}</p>} */}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-12 personal_details_dropdown">
                              <div className="form-group pos_relative">
                                <div className="multiselect_div">
                                  <CustomDropdown
                                    dropdownData={yearData}
                                    ShouldValidate={false}
                                    textboxError={true}
                                    dropdownValue={
                                      formValues.edu_undergrad_year
                                    }
                                    setDropdownValue={(value) =>
                                      handleInputChange(
                                        "edu_undergrad_year",
                                        value
                                      )
                                    }
                                    name=" year"
                                    DataRefechRetrigger={DataRefechRetrigger}
                                    fieldName="edu_undergrad_year"
                                    errors={errors}
                                    formValues={formValues}
                                    eventType={
                                      eventType === "Update" ? "Update" : "Add"
                                    }
                                    FeildName={"edu_undergrad_year"}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {([1, 2, 3, 4, 6].includes(applicationId) ||
                      (memberApplicationId === 2 &&
                        eventType === "Update")) && (
                        <>
                          <div className="col-md-12">
                            <div className="row">
                              <div className="col-lg-3 col-md-12">
                                <div className="form-group pos_relative">
                                  <label>
                                    Post Graduation{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="row">
                                  <div className="col-lg-4 col-md-12">
                                    <div className="form-group pos_relative">
                                      <input
                                        type="text"
                                        className={`form-control ${errors.edu_postgrad_degree
                                          ? "red_border"
                                          : ""
                                          }`}
                                        value={formValues.edu_postgrad_degree}
                                        placeholder="Degree"
                                        onChange={(e) =>
                                          handleInputChange(
                                            "edu_postgrad_degree",
                                            e.target.value
                                          )
                                        }
                                      />
                                      {errors && (
                                        <p className="text-danger pos_abos white_space">
                                          {errors.edu_postgrad_degree}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-12">
                                    <div className="form-group pos_relative">
                                      <input
                                        type="text"
                                        className={`form-control ${errors.edu_postgrad_college
                                          ? "red_border"
                                          : ""
                                          }`}
                                        value={formValues.edu_postgrad_college}
                                        placeholder="College"
                                        onChange={(e) =>
                                          handleInputChange(
                                            "edu_postgrad_college",
                                            e.target.value
                                          )
                                        }
                                      />
                                      {/* {errors &&
                                <p className="text-danger pos_abos">{errors.edu_postgrad_college}</p>} */}
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-12">
                                    <div className="form-group pos_relative">
                                      <input
                                        type="text"
                                        className={`form-control ${errors.edu_postgrad_university
                                          ? "red_border"
                                          : ""
                                          }`}
                                        value={formValues.edu_postgrad_university}
                                        placeholder="University"
                                        onChange={(e) =>
                                          handleInputChange(
                                            "edu_postgrad_university",
                                            e.target.value
                                          )
                                        }
                                      />
                                      {/* {errors &&
                                <p className="text-danger pos_abos">{errors.edu_postgrad_university}</p>} */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-12 personal_details_dropdown">
                                <div className="form-group pos_relative">
                                  <div className="multiselect_div">
                                    <CustomDropdown
                                      dropdownData={yearData}
                                      dropdownValue={formValues.edu_postgrad_year}
                                      ShouldValidate={false}
                                      textboxError={true}
                                      setDropdownValue={(value) =>
                                        handleInputChange(
                                          "edu_postgrad_year",
                                          value
                                        )
                                      }
                                      name="year"
                                      DataRefechRetrigger={DataRefechRetrigger}
                                      fieldName="edu_postgrad_year"
                                      errors={errors}
                                      formValues={formValues}
                                      eventType={
                                        eventType === "Update" ? "Update" : "Add"
                                      }
                                      FeildName={"edu_postgrad_year"}
                                    />
                                    {/* {errors &&
                              <p className="text-danger pos_abos">{errors.edu_postgrad_year}</p>} */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    {([1, 2, 3, 4, 6].includes(applicationId) ||
                      (memberApplicationId === 2 &&
                        eventType === "Update")) && (
                        <>
                          <div className="col-md-12">
                            <div className="row">
                              <div className="col-lg-3 col-md-12">
                                <div className="form-group pos_relative">
                                  <label>Super Speciality</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="row">
                                  <div className="col-lg-4 col-md-12">
                                    <div className="form-group pos_relative">
                                      <input
                                        type="text"
                                        className="form-control"
                                        // className={`form-control ${errors.edu_superspecialty_degree ? 'red_border' : ''}`}
                                        value={
                                          formValues.edu_superspecialty_degree
                                        }
                                        placeholder="Degree"
                                        onChange={(e) =>
                                          handleInputChange(
                                            "edu_superspecialty_degree",
                                            e.target.value
                                          )
                                        }
                                      />
                                      {/* {errors &&
                          <p className="text-danger pos_abos">{errors.edu_superspecialty_degree}</p>} */}
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-12">
                                    <div className="form-group pos_relative">
                                      <input
                                        type="text"
                                        className="form-control"
                                        // className={`form-control ${errors.edu_superspecialty_college ? 'red_border' : ''}`}
                                        value={
                                          formValues.edu_superspecialty_college
                                        }
                                        placeholder="College"
                                        onChange={(e) =>
                                          handleInputChange(
                                            "edu_superspecialty_college",
                                            e.target.value
                                          )
                                        }
                                      />
                                      {/* {errors &&
                          <p className="text-danger pos_abos">{errors.edu_superspecialty_college}</p>} */}
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-12">
                                    <div className="form-group pos_relative">
                                      <input
                                        type="text"
                                        className="form-control"
                                        // className={`form-control ${errors.edu_superspecialty_university ? 'red_border' : ''}`}
                                        value={
                                          formValues.edu_superspecialty_university
                                        }
                                        placeholder="University"
                                        onChange={(e) =>
                                          handleInputChange(
                                            "edu_superspecialty_university",
                                            e.target.value
                                          )
                                        }
                                      />
                                      {/* {errors &&
                          <p className="text-danger pos_abos">{errors.edu_superspecialty_university}</p>} */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-12 personal_details_dropdown">
                                <div className="form-group pos_relative">
                                  <div className="multiselect_div">
                                    <CustomDropdown
                                      dropdownData={yearData}
                                      dropdownValue={
                                        formValues.edu_superspecialty_year
                                      }
                                      setDropdownValue={(value) =>
                                        handleInputChange(
                                          "edu_superspecialty_year",
                                          value
                                        )
                                      }
                                      name="year"
                                      ShouldValidate={false}
                                      DataRefechRetrigger={DataRefechRetrigger}
                                      fieldName="edu_superspecialty_year"
                                      errors={errors}
                                      formValues={formValues}
                                      eventType={
                                        eventType === "Update" ? "Update" : "Add"
                                      }
                                      FeildName={"edu_superspecialty_year"}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12 col-md-12"></div>
                            </div>
                          </div>
                        </>
                      )}
                    {([1, 2, 3, 4, 6].includes(applicationId) ||
                      (memberApplicationId === 2 &&
                        eventType === "Update")) && (
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group pos_relative">
                            <label>
                              NMC/State Medical Council number{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${errors.mci_council_number ? "red_border" : ""
                                }`}
                              value={formValues.mci_council_number}
                              onChange={(e) => {
                                let input = e.target.value;
                                input = input.replace(/[^A-Za-z0-9]/g, ""); // Removes everything except letters and numbers
                                handleInputChange("mci_council_number", input);
                              }}
                            />
                           <small>
                              (Only numbers and alphabetic characters are
                              allowed.)
                          </small>                           
                            {errors && (
                              <p className="text-danger pos_abos">
                                {errors.mci_council_number}
                              </p>
                            )}
                          </div>
                        </div>
                      )}
                    {(([1, 2, 4, 6].includes(applicationId) ||
                      (memberApplicationId === 2 &&
                        eventType === "Update")) && `${formValues.country}`==="101" ) && (
                        <div className="col-lg-6 col-md-12 personal_details_dropdown">
                          <div className="form-group pos_relative">
                            <label>
                              NMC State <span className="text-danger">*</span>
                            </label>
                            <div className="multiselect_div">
                              <CustomDropdown
                                dropdownData={asiMciStateData}
                                dropdownValue={formValues.mci_council_state}
                                setDropdownValue={(value) =>
                                  handleInputChange("mci_council_state", value)
                                }
                                ShouldValidate={true}
                                name="NMC state"
                                DataRefechRetrigger={DataRefechRetrigger}
                                fieldName="mci_council_state"
                                errors={errors}
                                formValues={formValues}
                                eventType={
                                  eventType === "Update" ? "Update" : "Add"
                                }
                                FeildName={"common"}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    {(([1, 2, 4, 6].includes(applicationId) ||
                      (memberApplicationId === 2 &&
                        eventType === "Update")) && `${formValues.country}`==="101" ) && (
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group pos_relative">
                            <label>IMR Registration Number</label>
                            <input
                              type="text"
                              className="form-control"
                              // className={`form-control ${errors.imr_reg_no ? 'red_border' : ''}`}
                              value={formValues.imr_reg_no}
                              onChange={(e) => {
                                let input = e.target.value;
                                input = input.replace(/[^A-Za-z0-9]/g, ""); // Removes everything except letters and numbers
                                handleInputChange("imr_reg_no", input);
                              }}
                            />
                          <small>
                              (Only numbers and alphabetic characters are
                              allowed.)
                          </small>                            
                            {/* {errors &&
                    <p className="text-danger pos_abos">{errors.imr_reg_no}</p>} */}
                          </div>
                        </div>
                      )}
                    {([1, 2, 3, 4, 6].includes(applicationId) ||
                      (memberApplicationId === 2 &&
                        eventType === "Update")) && (
                        <div className="col-md-6" />
                      )}
                    {([1, 5, 6].includes(applicationId) && `${formValues.country}`==="101" )&& (
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group pos_relative">
                          <label>
                            ASI Membership Number{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.asi_membership_no ? "red_border" : ""
                              }`}
                            value={formValues.asi_membership_no}
                            onChange={(e) => {
                              let input = e.target.value;
                              input = input.replace(/[^A-Za-z0-9]/g, ""); // Removes everything except letters and numbers
                              handleInputChange("asi_membership_no", input);
                            }}
                          />
                          <small>
                              (Only numbers and alphabetic characters are
                              allowed.)
                          </small>
                          {errors && (
                            <p className="text-danger pos_abos">
                              {errors.asi_membership_no}
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                    {([1, 5, 6].includes(applicationId) && `${formValues.country}`==="101" ) && (
                      <div className="col-lg-6 col-md-12 personal_details_dropdown">
                        <div className="form-group pos_relative">
                          <label>
                            ASI State <span className="text-danger">*</span>
                          </label>
                          <div className="multiselect_div">
                            <CustomDropdown
                              dropdownData={asiMciStateData}
                              dropdownValue={formValues.asi_state}
                              setDropdownValue={(value) =>
                                handleInputChange("asi_state", value)
                              }
                              name="Asi state"
                              DataRefechRetrigger={DataRefechRetrigger}
                              fieldName="asi_state"
                              errors={errors}
                              formValues={formValues}
                              ShouldValidate={true}
                              eventType={
                                eventType === "Update" ? "Update" : "Add"
                              }
                              FeildName={"common"}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {([1, 2, 3, 4, 6].includes(applicationId) ||
                      (memberApplicationId === 2 &&
                        eventType === "Update")) && (
                        <div className="col-lg-6 col-md-12">
                          <label>Any other international Organisations</label>
                          {organisationsData.map((org) => (
                            <div key={org.id}>
                              <label>
                                <FormCheck
                                  type="checkbox"
                                  id={`checkbox-${org}`}
                                  label={org}
                                  checked={formValues.other_inter_organisation?.includes(
                                    org
                                  )}
                                  onChange={(e) =>
                                    handleOtherOrganizationChange(e, org)
                                  }
                                />
                              </label>
                            </div>
                          ))}
                          {formValues.other_inter_organisation?.includes(
                            "Others"
                          ) && (
                              <input
                                type="text"
                                className={`form-control`}
                                // className={`form-control ${errors.landline ? "red_border" : ""}`}
                                placeholder="Please Mention"
                                value={formValues.other_inter_organisation_value}
                                onChange={(e) =>
                                  handleInputChange(
                                    "other_inter_organisation_value",
                                    e.target.value
                                  )
                                }
                              />
                            )}
                        </div>
                      )}
                    {([1, 2, 3, 4, 6].includes(applicationId) ||
                      (memberApplicationId === 2 &&
                        eventType === "Update")) && (
                        <>
                          <div className="col-md-12 pt-3">
                            <div className="row">
                              <div className="col-md-6">
                                <div className="header">
                                  <h2>Work Experience</h2>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="text-right">
                                  <button
                                    onClick={() => addProceduresField()}
                                    type="button"
                                    className="btn btn-primary mb-2 mr-1 "
                                  >
                                    <i className="fa fa-plus" />{" "}
                                    <span>Add New</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3 desktop_view">
                            <p>Position</p>
                          </div>
                          <div className="col-md-3 desktop_view">
                            <p>Experience (From)</p>
                          </div>
                          <div className="col-md-3 desktop_view">
                            <p>Experience (To)</p>
                          </div>
                          <div className="col-md-3 desktop_view">
                            <p>Experience (Years)</p>
                          </div>
                          {procedures.map((data, index) => (
                            <>
                              <div className="col-md-12 desktop_view">
                                <div className="row pos_rel_fielsclear">
                                  <div className="col-lg-3 col-md-12">
                                    <div className="form-group pos_relative">
                                      <input
                                        type="text"
                                        className={`form-control ${proceduresErrors[
                                          `work_procedure-${index}`
                                        ]
                                          ? "red_border"
                                          : ""
                                          }`}
                                        value={data.work_procedure}
                                        onChange={(e) =>
                                          handleProceduresChange(
                                            index,
                                            "work_procedure",
                                            e.target.value
                                          )
                                        }
                                      />
                                      {proceduresErrors[
                                        `work_procedure-${index}`
                                      ] && (
                                          <p className="text-danger pos_abos">
                                            {
                                              proceduresErrors[
                                              `work_procedure-${index}`
                                              ]
                                            }
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="col-lg-3 col-md-12">
                                    <div className="form-group pos_relative">
                                      <Datepicker
                                        selectedDate={data.no_of_procedures1 ? new Date(data.no_of_procedures1) : null}
                                        onDateChange={(date) => {
                                          const formattedDate = date ? dayjs(date).format(dateFormatList) : "";
                                          handleProceduresChange(index, "no_of_procedures1", formattedDate);
                                        }}
                                        className={`form-control ${
                                          proceduresErrors[`no_of_procedures1-${index}`] ? "red_border" : ""
                                        }`}
                                        placeholder="DD/MM/YYYY"
                                      />
                                      {proceduresErrors[
                                        `no_of_procedures1-${index}`
                                      ] && (
                                          <p className="text-danger pos_abos">
                                            {
                                              proceduresErrors[
                                              `no_of_procedures1-${index}`
                                              ]
                                            }
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="col-lg-3 col-md-12">
                                    <div className="form-group pos_relative">
                                     <Datepicker
                                        selectedDate={data.no_of_procedures2 ? new Date(data.no_of_procedures2) : null}
                                        onDateChange={(date) => {
                                          const formattedDate = date ? dayjs(date).format(dateFormatList) : "";
                                          handleProceduresChange(index, "no_of_procedures2", formattedDate);
                                        }}
                                        className={`form-control ${
                                          proceduresErrors[`no_of_procedures2-${index}`] ? "red_border" : ""
                                        }`}
                                        placeholder="DD/MM/YYYY"
                                      />
                                      {proceduresErrors[
                                        `no_of_procedures2-${index}`
                                      ] && (
                                          <p className="text-danger pos_abos">
                                            {
                                              proceduresErrors[
                                              `no_of_procedures2-${index}`
                                              ]
                                            }
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="col-lg-2 col-md-12">
                                    <div className="form-group pos_relative wid_input_half">
                                      <input
                                        type="number"
                                        className={`form-control`}
                                        value={workExpInYears(data.no_of_procedures1, data.no_of_procedures2)}
                                        disabled
                                        onChange={(e) =>
                                          handleProceduresChange(
                                            index,
                                            "no_of_procedures2",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-1 col-md-12">
                                    {/* {procedures.length > 1 && ( */}
                                    <div
                                      onClick={() =>
                                        removeProceduresField(index, data.id)
                                      }
                                      className="btn btn-danger mb-2 mr-1"
                                      type="button"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </div>
                                    {/* )} */}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12 mobile_view">
                                <div className="row pos_rel_fielsclear">
                                  <div className="col-lg-3 col-md-12">
                                    <div className="form-group pos_relative">
                                      <p>Position</p>
                                      <input
                                        type="text"
                                        className={`form-control ${proceduresErrors[
                                          `work_procedure-${index}`
                                        ]
                                          ? "red_border"
                                          : ""
                                          }`}
                                        value={data.work_procedure}
                                        onChange={(e) =>
                                          handleProceduresChange(
                                            index,
                                            "work_procedure",
                                            e.target.value
                                          )
                                        }
                                      />
                                      {proceduresErrors[
                                        `work_procedure-${index}`
                                      ] && (
                                          <p className="text-danger pos_abos">
                                            {
                                              proceduresErrors[
                                              `work_procedure-${index}`
                                              ]
                                            }
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="col-lg-3 col-md-12">
                                    <div className="form-group pos_relative">
                                      <p>Experience (From)</p>
                                      <input
                                        type="date"
                                        onClick={(e) => e.target.showPicker()}
                                        className={`form-control ${proceduresErrors[
                                          `no_of_procedures1-${index}`
                                        ]
                                          ? "red_border"
                                          : ""
                                          }`}
                                        value={
                                          data.no_of_procedures1
                                            ? dayjs(
                                              data.no_of_procedures1
                                            ).format(dateFormatList)
                                            : ""
                                        }
                                        onChange={(e) =>
                                          handleProceduresChange(
                                            index,
                                            "no_of_procedures1",
                                            e.target.value
                                          )
                                        }
                                      />
                                      {proceduresErrors[
                                        `no_of_procedures1-${index}`
                                      ] && (
                                          <p className="text-danger pos_abos">
                                            {
                                              proceduresErrors[
                                              `no_of_procedures1-${index}`
                                              ]
                                            }
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="col-lg-3 col-md-12">
                                    <div className="form-group pos_relative">
                                      <p>Experience (To)</p>
                                      <input
                                        type="date"
                                        onClick={(e) => e.target.showPicker()}
                                        className={`form-control ${proceduresErrors[
                                          `no_of_procedures2-${index}`
                                        ]
                                          ? "red_border"
                                          : ""
                                          }`}
                                        value={
                                          data.no_of_procedures2
                                            ? dayjs(
                                              data.no_of_procedures2
                                            ).format(dateFormatList)
                                            : ""
                                        }
                                        onChange={(e) =>
                                          handleProceduresChange(
                                            index,
                                            "no_of_procedures2",
                                            e.target.value
                                          )
                                        }
                                      />
                                      {proceduresErrors[
                                        `no_of_procedures2-${index}`
                                      ] && (
                                          <p className="text-danger pos_abos">
                                            {
                                              proceduresErrors[
                                              `no_of_procedures2-${index}`
                                              ]
                                            }
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="col-md-12">
                                  <div className="row">
                                    <div className="col-lg-6 col-md-6 col-8">
                                      <div className="form-group pos_relative wid_input_half">
                                        <p>Experience (Years)</p>
                                        <input
                                          type="number"
                                          className={`form-control`}
                                          value={workExpInYears(data.no_of_procedures1, data.no_of_procedures2)}
                                          disabled
                                          onChange={(e) =>
                                            handleProceduresChange(
                                              index,
                                              "no_of_procedures2",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-4">
                                      {/* {procedures.length > 1 && ( */}
                                      <p className="height_21px"> </p>
                                      <div
                                        onClick={() =>
                                          removeProceduresField(index, data.id)
                                        }
                                        className="btn btn-danger mb-2 mr-1"
                                        type="button"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </div>
                                      {/* )} */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div >
                            </>
                      ))}
                  </>
                      )}
                  <div className="col-md-12">
                    <div className="header">
                      <h2>Documents</h2>
                    </div>
                  </div>

                  {/* {([1, 2, 6].includes(applicationId) || (memberApplicationId!==4&&eventType==="Update"))&&( */}
                  {(([1, 2, 6].includes(applicationId) ||
                    (memberApplicationId === 2 &&
                      eventType === "Update")) && `${formValues.country}`==="101" )&& (
                      <div className="col-md-12 col-12  pos_relative">
                        <div className="dropdown_cetifica_div">
                          <label>
                            NMC Certificate{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <br />
                          <small>
                            (Maximum file size allowed: 2MB ){" "}
                            <span>
                              Kindly do not upload password-protected pdf's
                            </span>{" "}
                          </small>
                        </div>
                        <SingleFileUpload
                          onFileUpload={handleMciCertificateUpload}
                          setFileError={setMciCertificateError}
                          fileError={mciCertificateError}
                        />
                        {/* {mciCertificateError && (
                          <p className="text-danger pos_abos left_15">
                            {mciCertificateError}
                          </p>
                        )} */}
                        {errors && (
                          <p className="text-danger pos_abos left_15">
                            {errors.mci_certificate}
                          </p>
                        )}
                        <div className="width-fit view_button_list_pos">
                          {eventType === "Update" &&
                            !mciCertificateFile &&
                            memberApplicationId !== 4 && (
                              <a
                                href={`${memberDetails.mci_certificate}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-info btn-block"
                              >
                                View Document
                              </a>
                            )}
                        </div>
                      </div>
                    )}

                  {(([1, 2, 3, 6].includes(applicationId) ||
                    (memberApplicationId === 2 &&
                      eventType === "Update")) || `${formValues.country}`!=="101" ) && (
                      <div className="col-md-12 col-12  pos_relative">
                        <div className="dropdown_cetifica_div">
                          <label>
                            PG Degree Certificate{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <br />
                          <small>
                            (Maximum file size allowed: 2MB ){" "}
                            <span>
                              Kindly do not upload password-protected pdf's
                            </span>{" "}
                          </small>
                        </div>
                        <SingleFileUpload
                          onFileUpload={handlePgDegreeCertificateUpload}
                          setFileError={setPgDegreeCertificateError}
                          fileError={pgDegreeCertificateError}
                        />
                        {/* {pgDegreeCertificateError && (
                          <p className="text-danger pos_abos left_15">
                            {pgDegreeCertificateError}
                          </p>
                        )} */}
                        {errors && (
                          <p className="text-danger pos_abos left_15">
                            {errors.pg_degree_certificate}
                          </p>
                        )}
                        <div className="width-fit view_button_list_pos">
                          {" "}
                          {eventType === "Update" &&
                            !pgDegreeCertificateFile &&
                            memberApplicationId !== 4 && (
                              <a
                                href={`${memberDetails.pg_degree_certificate}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-info btn-block"
                              >
                                View Document
                              </a>
                            )}
                        </div>
                      </div>
                    )}

                  {([1, 5, 6].includes(applicationId) && `${formValues.country}`==="101")&& (
                    <div className="col-md-12 col-12  pos_relative">
                      <div className="dropdown_cetifica_div">
                        <label>
                          ASI Membership Certificate{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <br />
                        <small>
                          (Maximum file size allowed: 2MB ){" "}
                          <span>
                            Kindly do not upload password-protected pdf's
                          </span>{" "}
                        </small>
                      </div>
                      <SingleFileUpload
                        onFileUpload={handleAsiMemberCertificateUpload}
                        setFileError={setAsiMemberCertificateError}
                        fileError={asiMemberCertificateError}
                      />
                      {/* {asiMemberCertificateError && (
                        <p className="text-danger pos_abos left_15">
                          {asiMemberCertificateError}
                        </p>
                      )} */}
                      {errors && (
                        <p className="text-danger pos_abos left_15">
                          {errors.asi_member_certificate}
                        </p>
                      )}
                      <div className="width-fit view_button_list_pos">
                        {eventType === "Update" &&
                          !asiMemberCertificateFile &&
                          ![2, 4].includes(memberApplicationId) && (
                            <a
                              href={`${memberDetails.asi_member_certificate}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-outline-info btn-block"
                            >
                              View Document
                            </a>
                          )}
                      </div>
                    </div>
                  )}

                  {([3].includes(applicationId) || `${formValues.country}`!=="101")&& (
                    <div className="col-md-12 col-12  pos_relative">
                      <div className="dropdown_cetifica_div">
                        <label>
                          Active License for Practicing Surgeons{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <br />
                        <small>
                          (Maximum file size allowed: 2MB ){" "}
                          <span>
                            Kindly do not upload password-protected pdf's
                          </span>{" "}
                        </small>
                      </div>
                      <SingleFileUpload
                        onFileUpload={handleActiveLicenseUpload}
                        setFileError={setActiveLicenseError}
                        fileError={activeLicenseError}
                      />
                      {/* {activeLicenseError && (
                        <p className="text-danger pos_abos left_15">
                          {activeLicenseError}
                        </p>
                      )} */}
                      {errors && (
                        <p className="text-danger pos_abos left_15">
                          {errors.active_license}
                        </p>
                      )}
                      <div className="width-fit view_button_list_pos">
                        {eventType === "Update" && !activeLicenseFile && (
                          <a
                            href={`${memberDetails.active_license}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-outline-info btn-block"
                          >
                            View Document
                          </a>
                        )}
                      </div>
                    </div>
                  )}

                  {(([4].includes(applicationId) ||
                    (memberApplicationId === 4 &&
                      eventType === "Update")) && `${formValues.country}`==="101") && (
                      <div className="col-md-12 col-12  pos_relative">
                        <div className="dropdown_cetifica_div">
                          <label>
                            Letter from HOD{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <br />
                          <small>
                            (Maximum file size allowed: 2MB ){" "}
                            <span>
                              Kindly do not upload password-protected pdf's
                            </span>{" "}
                          </small>
                        </div>
                        <SingleFileUpload
                          onFileUpload={handleHodLetterUpload}
                          setFileError={setHodLetterError}
                          fileError={hodLetterError}
                        />
                        {/* {hodLetterError && (
                          <p className="text-danger pos_abos left_15">
                            {hodLetterError}
                          </p>
                        )} */}
                        {errors && (
                          <p className="text-danger pos_abos left_15">
                            {errors.letter_hod}
                          </p>
                        )}
                        <div className="width-fit view_button_list_pos">
                          {eventType === "Update" && !hodLetterFile && (
                            <a
                              href={`${memberDetails.letter_hod}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-outline-info btn-block"
                            >
                              View Document
                            </a>
                          )}
                        </div>
                      </div>
                    )}

                  {(([4].includes(applicationId) ||
                    (memberApplicationId === 4 &&
                      eventType === "Update")) && `${formValues.country}`==="101") && (
                      <div className="col-md-12 col-12  pos_relative">
                        <div className="dropdown_cetifica_div">
                          <label>
                            MBBS Degree certificate{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <br />
                          <small>
                            (Maximum file size allowed: 2MB ){" "}
                            <span>
                              Kindly do not upload password-protected pdf's
                            </span>{" "}
                          </small>
                        </div>
                        <SingleFileUpload
                          onFileUpload={handleMbbsDegreeCertificateUpload}
                          setFileError={setMbbsDegreeCertificateError}
                          fileError={mbbsDegreeCertificateError}
                        />
                        {/* {mbbsDegreeCertificateError && (
                          <p className="text-danger pos_abos left_15">
                            {mbbsDegreeCertificateError}
                          </p>
                        )} */}
                        {errors && (
                          <p className="text-danger pos_abos left_15">
                            {errors.mbbs_degree_certificate}
                          </p>
                        )}
                        <div className="width-fit view_button_list_pos">
                          {eventType === "Update" &&
                            !mbbsDegreeCertificateFile && (
                              <a
                                href={`${memberDetails.mbbs_degree_certificate}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-info btn-block"
                              >
                                View Document
                              </a>
                            )}
                        </div>
                      </div>
                    )}

                  <div className="col-md-12 pt-5 pb-3">
                    <div className="last_form_submit_flex">
                      <div>
                        <button
                          onClick={() => clearInputValues()}
                          className="btn btn-outline-danger btn-block saveand_proced_button"
                          type="button"
                        >
                          Back{" "}
                        </button>
                      </div>
                      <div>
                        {/* <button
                          onClick={() => addUpdateMembershipApplication()}
                          className="btn btn-info btn-block saveand_proced_button"
                          type="button"
                        >
                          {eventType === "Update"
                            ? "Update"
                            : "Save & proceed"}
                        </button> */}
                     <button
                         onClick={() => addUpdateMembershipApplication()}
                          className="btn btn-info btn-block saveand_proced_button"
                          type="button"
                            disabled={isLoadingSubmit}
                        >
                        {isLoadingSubmit ? (
                                <>
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    <span className="ms-2">Processing...</span>
                                </>
                            ) : (
                            eventType === "Update"
                            ? "Update"
                            : "Save & proceed"
                         )}
                        </button>
                      </div>
                    </div>
                  </div>
              </div>
            </fieldset>
          </div>
        </div>
          </div >
        </div >
      )}
    </>
  );
};
export default UpdateMembershipApplicationComponent;
